import type SearchHistoryDataService from './search-history.data-service';
import type {SearchHistoryEntryDto} from 'typings/portaro.be.types';
import KpVisitedPanel from '../commons/components/kp-visited-panel/KpVisitedPanel.svelte';
import KpFavouritesPanel from '../commons/components/kp-favourites-panel/KpFavouritesPanel.svelte';

export default class SearchHistoryController {
    public static readonly controllerName = 'SearchHistoryController';

    public history: SearchHistoryEntryDto[];
    public kpVisitedPanelComponent = KpVisitedPanel;
    public kpFavouritesPanelComponent = KpFavouritesPanel;

    /*@ngInject*/
    constructor(searchHistoryDataService: SearchHistoryDataService) {
        searchHistoryDataService.getAll().then((history) => this.history = history);
    }
}